





























import { defineComponent } from '@nuxtjs/composition-api';
import { DocumentNode } from '@shared/components/RichTextDisplay/types';
import useResponsive from '@shared/composables/useResponsive';
import { getPlaceholderImage } from '@shared/composables/useUiHelpers';
import { BaseButton, BaseHeading, BaseImage } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import TruncatedReadMoreTextContainer from '~/components/TruncatedReadMoreTextContainer/TruncatedReadMoreTextContainer.vue';

export default defineComponent({
  name: 'ContentCard',
  components: {
    BaseImage,
    BaseHeading,
    TruncatedReadMoreTextContainer,
    BaseButton,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { isMobile } = useResponsive();
    return {
      isMobile,
    };
  },
  computed: {
    title(): string {
      return this.content?.content?.title;
    },
    description(): string | DocumentNode {
      return this.content?.content?.description || '';
    },
    thumbnailImageSrc(): string {
      const image = this.content?.content?.image ?? this.content?.content?.thumb_image;
      return (
        getStoryblokImageURL(image?.filename, { width: 500 }) || getPlaceholderImage().filename
      );
    },
    thumbnailImageAlt(): string {
      const image = this.content?.content?.image ?? this.content?.content?.thumb_image;
      return image?.alt || getPlaceholderImage().alt;
    },
    contentUrl(): string {
      return `/${this.content?.content?.cta_link?.cached_url ?? this.content.full_slug ?? ''}`;
    },
    tag(): string {
      return this.content?.content?.tag ?? this.content?.content?.category?.name ?? '';
    },
    ctaText(): string {
      return this.content?.content?.cta_link_text || 'View More';
    },
    truncationLines(): number {
      return this.isMobile ? 5 : 3;
    },
  },
});
